import type { OwaDate } from '../../../schema';
import type { GlobalCalendarLocale } from '../../../intl/globalCalendarLocale';
import addDays from '../../../owaDate/addDays';
import getIntlDateBase from '../base/getIntlDateBase';

export default function getIntlDateHijri(
    date: OwaDate,
    locale: GlobalCalendarLocale,
    format: 'numeric' | '2-digit'
): string {
    const adjustedDate = addDays(date, locale.hijriOffset);

    return getIntlDateBase(adjustedDate, locale, format);
}
